<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3">
                <div class="form-group col-lg-3">
                    <label for="area">{{ $t('omsz-form.labels.area') }}</label>
                    <multiselect id="area"
                                 v-model="area"
                                 track-by="name"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="areas"
                                 :allow-empty="false"
                                 :disabled="isDisabled">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
                <div class="form-group col-lg-3">
                    <label for="element">{{ $t('omsz-form.labels.pollutant') }}</label>
                    <multiselect id="element"
                                 v-model="element"
                                 track-by="name"
                                 label="name"
                                 :placeholder="$t('omsz-form.placeholders.select')"
                                 :select-label="$t('omsz-form.placeholders.select_enter')"
                                 :selected-label="$t('omsz-form.placeholders.selected')"
                                 :deselect-label="$t('omsz-form.placeholders.remove')"
                                 :options="elements"
                                 :allow-empty="false"
                                 :disabled="isDisabled">
                        <template slot="component_area" slot-scope="{ option }">{{ option.name }}</template>
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
                <div class="form-group buttons ml-auto d-flex align-items-end">
                    <button
                        id="clear_form"
                        type="button"
                        class="btn btn-link text-uppercase mr-3"
                        :disabled="!(area && element) || isLoading"
                        @click="clearAll">
                        <span>{{ $t('omsz.buttons.clear_filters') }}</span>
                    </button>
                    <button id="send" class="btn btn-primary" type="submit" :disabled="!(area && element) || isLoading">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>

        <span v-show="isLoading">{{ $t('omsz.placeholders.please_wait') }}</span>
        <div v-if="errorMessage">{{ errorMessage }}</div>

        <air-pollution v-if="airPollutionData" :air-pollution-data="airPollutionData" @area-change="onArea"/>
    </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import AirPollution from './AirPollution';

export default {
    name: 'air-pollution-network',
    components: {
        Multiselect,
        AirPollution,
    },
    props: {
        areas: {
            type: Array,
            required: true,
        },
        elements: {
            type: Array,
            required: true,
        },
        defaults: {
            type: Object,
            default: {
                area: null,
                element: null,
            },
        },
    },
    data() {
        return {
            area: null,
            element: null,
            isLoading: false,
            isDisabled: false,
            errorMessage: null,
            airPollutionData: null,
        };
    },
    methods: {
        clearAll(e) {
            this.area = null;
            this.element = null;
        },

        async submit() {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;

            this.airPollutionData = null;
            this.errorMessage = null;

            axios.post('/api/modelling/map-data', {
                area: this.area.value,
                element: this.element.value,
            }).then(({ data }) => {
                this.airPollutionData = Object.assign(data, { element: this.element });
            }).catch(error => {
                this.errorMessage = this.$t('omsz-form.errors.no_result');
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onArea(areaId) {
            this.area = this.areas.find(option => option.value === areaId);
            this.submit();
        }
    },
    created() {
        if (this.defaults.area.value) {
            this.area = this.areas.find(option => option.value === this.defaults.area.value);
        }

        if (this.defaults.element.value) {
            this.element = this.elements.find(option => option.value === this.defaults.element.value);
        }

        this.submit();
    },
}
</script>
